/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { StreamsService } from '../services/streams.service';

const streamsState = {
  streams: [],
};

const mutations = {
  setStreams(state, streams) {
    // eslint-disable-next-line
    state.streams = streams ? streams : [];
  },
};

const getters = {
  streams: state => state.streams,
};

const actions = {
  getStreams: async ({ commit }) => {
    try {
      const streams = await StreamsService.getStreams();
      commit('setStreams', streams);
      return true;
    } catch (e) {
      return false;
    }
  },
  createStream: async ({ dispatch }, payload) => {
    try {
      await StreamsService.createStream(payload);
      await dispatch('getStreams');
      return true;
    } catch (e) {
      return false;
    }
  },
  removeStream: async ({ dispatch }, id) => {
    try {
      await StreamsService.removeStream(id);
      await dispatch('getStreams');
      return true;
    } catch (e) {
      return false;
    }
  },
  // eslint-disable-next-line
  metrics: async ({}, { id, start, end, step = 30 }) => {
    try {
      const metrics = await StreamsService.getMetrics(id, { start, end }, step);
      return metrics;
    } catch (e) {
      return false;
    }
  },
  // eslint-disable-next-line
  deviceCPU: async ({}, { id, start, end, step = 30 }) => {
    try {
      const metrics = await StreamsService.getDeviceCPU(id, { start, end }, step);
      return metrics;
    } catch (e) {
      return false;
    }
  },
  // eslint-disable-next-line
  deviceBattery: async ({}, { id, start, end, step = 30 }) => {
    try {
      const metrics = await StreamsService.getDeviceBattery(id, { start, end }, step);
      return metrics;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: streamsState,
  mutations,
  getters,
  actions,
};
